import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="section-title">平台优势</h2>
          <p className="section-subtitle">为什么百万吃瓜群众选择91吃瓜爆料</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6 hover:border-primary-200 transition-all duration-300 cursor-pointer text-center"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-4 rounded-xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-primary-600 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}